import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { Question } from './../../models/QuestionCreateData';
import { EvaluationQuestionState, EvaluationQuestionTypes, Questions } from './types';

const INITIAL_STATE: EvaluationQuestionState = {
    data: undefined,
    list: {} as Questions,
    isNew: false,
    loading: false,
    hasError: false,
    success: false,
    successOnDelete: false,
};

const reducer: Reducer<EvaluationQuestionState> = (state: EvaluationQuestionState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case EvaluationQuestionTypes.GET_QUESTION_REQUEST:
            return { ...state, loading: true };
        case EvaluationQuestionTypes.GET_QUESTION_SUCCESS:
            return { ...state, loading: false, data: { ...action.payload } };
        case EvaluationQuestionTypes.GET_QUESTION_FAILURE:
            return { ...state, hasError: true };
        case EvaluationQuestionTypes.GET_QUESTION_CLEAR:
            return { ...state, data: undefined };
        case EvaluationQuestionTypes.GET_QUESTIONS_REQUEST:
            return { ...state, loading: true };
        case EvaluationQuestionTypes.GET_QUESTIONS_SUCCESS:
            return { ...state, loading: false, list: { ...state.list, questions: action.payload } };
        case EvaluationQuestionTypes.GET_QUESTIONS_FAILURE:
            return { ...state, hasError: true };
        case EvaluationQuestionTypes.POST_QUESTION_REQUEST:
            return { ...state, loading: true, success: false };
        case EvaluationQuestionTypes.POST_QUESTION_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                data: { ...action.payload },
                list: { ...state.list, questions: [...state.list.questions, action.payload] },
            };
        case EvaluationQuestionTypes.POST_QUESTION_FAILURE:
            return { ...state, hasError: true, success: false };
        case EvaluationQuestionTypes.PUT_QUESTION_REORDER_REQUEST:
            return { ...state, loading: true };
        case EvaluationQuestionTypes.PUT_QUESTION_REORDER_SUCCESS:
            return { ...state, loading: false };
        case EvaluationQuestionTypes.PUT_QUESTION_REORDER_FAILURE:
            return { ...state, hasError: true };

        case EvaluationQuestionTypes.POST_QUESTION_RENEW_REQUEST:
            return { ...state, loading: true, isNew: false, success: false };
        case EvaluationQuestionTypes.POST_QUESTION_RENEW_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                isNew: true,
                data: undefined,
                list: { ...state.list, questions: [...state.list.questions, action.payload] },
            };
        case EvaluationQuestionTypes.POST_QUESTION_RENEW_CLEAR:
            return { ...state, loading: false, data: undefined, success: false };
        case EvaluationQuestionTypes.PUT_QUESTION_REQUEST:
            return { ...state, loading: true };
        case EvaluationQuestionTypes.PUT_QUESTION_SUCCESS:
            return { ...state, list: { questions: updateQuestion([...state.list.questions], { ...action.payload }) }, loading: false };
        case EvaluationQuestionTypes.PUT_QUESTION_FAILURE:
            return { ...state, hasError: true, loading: false };
        case EvaluationQuestionTypes.DELETE_QUESTION_REQUEST:
            return { ...state, loading: true, successOnDelete: false };
        case EvaluationQuestionTypes.DELETE_QUESTION_SUCCESS:
            return {
                ...state,
                list: { questions: deleteQuestion([...state.list.questions], action.payload.questionId) },
                loading: false,
                data: undefined,
                successOnDelete: true,
            };
            return { ...state, data: undefined, successOnDelete: true };
        case EvaluationQuestionTypes.DELETE_QUESTION_FAILURE:
            return { ...state, hasError: true, successOnDelete: false };
        default:
            return state;
    }
};

const updateQuestion = (currentQuestions: Question[], updatedQuestion: Question) => {
    const originalQuestion = currentQuestions.find((el) => el.id === updatedQuestion.id);
    Object.assign(currentQuestions[currentQuestions.findIndex((el) => el.id === updatedQuestion.id)], {
        ...originalQuestion,
        description: updatedQuestion.description,
        options: updatedQuestion.options,
    });
    return currentQuestions;
};

const deleteQuestion = (currentQuestions: Question[], questionId: number) => {
    const indexToDelete = currentQuestions.findIndex((el) => el.id === questionId);
    currentQuestions.splice(indexToDelete, 1);
    return currentQuestions;
};

export default reducer;
